import React, { useState } from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  kbd: {
    backgroundColor: '#eee',
    borderRadius: '3px',
    border: '1px solid #b4b4b4',
    boxShadow: '0 1px 1px rgba(0, 0, 0, .2), 0 2px 0 0 rgba(255, 255, 255, .7) inset',
    color: '#333',
    display: 'inline - block',
    fontSize: '.85em',
    fontSeight: 700,
    lineHeight: 1,
    padding: '2px 4px',
    whiteSpace: 'nowrap'
  }
});

const SignaturePositionsInfoAlert = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [showAlert, setShowAlert] = useState(!localStorage.getItem('signaturePositionsAlertClosed'));

  const handleClose = () => {
    localStorage.setItem('signaturePositionsAlertClosed', 'true');
    setShowAlert(false);
  };

  if (!showAlert) {
    return null;
  }

  return (
    <Alert severity='info' onClose={handleClose}>
      <AlertTitle color='inherit'>{t('processDetail:signaturePositionsInfo:title')}</AlertTitle>
      <Trans i18nKey='processDetail:signaturePositionsInfo:message' components={{ kbd: <kbd className={classes.kbd} /> }} />
    </Alert>
  );
};

export default SignaturePositionsInfoAlert;
